<template>
  <div id="custForm">
    <!-- leave to build css specific changes-->
    <a-form class="login-form" :form="form" @submit="handleSubmit" novalidate>
      <a-form-item>
        <a-input-search
          @blur="searchCustomer"
          @search="searchCustomer"
          @pressEnter="searchCustomer"
          @touchleave="searchCustomer"
          @change="handleEmailChange"
          name="email"
          autocomplete="email"
          placeholder="Email"
          size="large"
          class="email-search"
          v-decorator="[
            'email',
            {
              rules: [
                {
                  type: 'email',
                  message: 'La dirección de correo es inválida.'
                },
                {
                  required: true,
                  message: 'Por favor, ingresa la dirección de correo.'
                }
              ]
            }
          ]"
        >
          <span slot="prefix" style="color: rgba(0,0,0,.25);">@</span>
          <a-button
            v-if="customerValidationError"
            slot="enterButton"
            type="primary"
            style="font-size:18px; background-color: #f39834; border-color:#f39834"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a-icon
              type="exclamation-circle"
            />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-button
          >
          <a-button
            v-else-if="customerValidated && displayCustomerDetails"
            slot="enterButton"
            type="primary"
            style="font-size:18px"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a-icon
              type="check-circle"
            />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-button
          >
          <a-button
            v-else-if="customerValidated && !displayCustomerDetails"
            slot="enterButton"
            type="primary"
            >Registrado <a-icon style="font-size:16px" type="check-circle"
          /></a-button>
          <a-button
            v-else-if="validatingCustomer"
            slot="enterButton"
            type="primary"
            icon="user"
            :loading="true"
          >
            Validando...
          </a-button>
          <a-button v-else slot="enterButton" type="primary" icon="user"
            >Validar
          </a-button>
        </a-input-search>
      </a-form-item>

      <span v-if="displayCustomerDetails">
        <a-form-item style="margin-bottom:0">
          <a-form-item has-feedback>
            <a-input
              name="fname"
              autocomplete="given-name"
              placeholder="Nombre"
              ref="firstName"
              size="large"
              v-decorator="[
                'firstName',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Por favor, ingresa el nombre.'
                    }
                  ]
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="font-size"
                style="color: rgba(0,0,0,.25);"
              />
            </a-input>
          </a-form-item>

          <a-form-item has-feedback>
            <a-input
              name="lname"
              autocomplete="family-name"
              placeholder="Apellido"
              size="large"
              v-decorator="[
                'lastName',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Por favor, ingresa el apellido.'
                    }
                  ]
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="font-size"
                style="color: rgba(0,0,0,.25);"
              />
            </a-input>
          </a-form-item>
        </a-form-item>

        <a-form-item has-feedback>
          <a-input
            name="tel"
            autocomplete="tel"
            placeholder="Whatsapp (Ej: 11 4939-5005)"
            size="default"
            v-decorator="[
              'tel',
              {
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingresa un telefono.'
                  }
                ]
              }
            ]"
          >
            <a-select
              slot="addonBefore"
              v-decorator="[
                'prefix',
                {
                  initialValue: '+549'
                }
              ]"
              style="width: 90px"
            >
              <a-select-option
                v-for="code in telCountryCodes"
                :key="code.value"
                :value="code.value"
              >
                {{ code.label }}
              </a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
      </span>
    </a-form>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import store from "@/store";
import errors from "@/services/errors";
import utils from "@/services/utils";

export default {
  name: "customerForm",
  props: {
    subscriptionUUID: { default: null }
  },
  data: function() {
    return {
      //linkToken: this.$route.params.linkToken,
      form: this.$form.createForm(this),
      loading: false,
      customerFieldsDisabled: false,
      validatingCustomer: false,
      displayCustomerDetails: false,
      customerValidated: false,
      customerValidationError: false,
      telCountryCodes: utils.getTelCountryCodes()
    };
  },
  methods: {
    ...mapActions({}),
    async handleSubmit() {
      let formData = false;
      //this.form.preventDefault();
      this.form.validateFields((error, formInput) => {
        if (!error && this.customerValidated) {
          formData = {
            email: formInput.email,
            firstName: formInput.firstName,
            lastName: formInput.lastName,
            tel: formInput.prefix + formInput.tel
          };
          //formData = formInput;
        } else {
          console.log("error", error);
        }
      });
      return formData;
    },
    async searchCustomer(event) {
      try {
        const val = event.target.value;
        let emailError = false;
        this.form.validateFields(["email"], (err, values) => {
          if (err) emailError = true;
        });

        if (val.length > 0 && !emailError) {
          this.validatingCustomer = true;
          const payload = {
            email: val,
            subscriptionUUID: this.subscriptionUUID
          };
          const res = await Vue.prototype.$axios.post(
            //`/public/customers/check/${encodeURIComponent(val)}`,
            `/public/customers/check`,
            payload
          );
          this.validatingCustomer = false;
          /*
          this.form.validateFields(["email"], {
            suppressWarning: true,
            force: true
          });
          */
          if (res.status == 200) {
            if (res.data.customerRegistered) {
              this.customerValidated = true;
              this.displayCustomerDetails = false;
              this.form.resetFields(["firstName", "lastName", "prefix", "tel"]);
              //need a timeout to trigger after other interference events
              window.setTimeout(() => {
                document.getElementById("cardNumber").focus();
              }, 300);
            } else {
              this.customerValidated = true;
              this.displayCustomerDetails = true;
              //need a timeout to trigger after other interference events
              window.setTimeout(() => {
                document.getElementById("firstName").focus();
              }, 300);
            }
          } else if (res.status == 400) {
            //error en los datos del request.
            //no hay error pero el cliente ya esta registrado a la suscripción
            this.customerValidated = false;
            this.customerValidationError = true;
            const message =
              res.data.message ||
              "Hubo un error al intentar validar el cliente.";
            this.$notification["warning"]({
              message: "Error",
              description: message
            });
          } else if (res.status == 404) {
            //no hay error pero el cliente ya esta registrado a la suscripción
            this.customerValidated = false;
            this.customerValidationError = true;
            this.$notification["warning"]({
              message: "Error",
              description: "El cliente ya se encuentra registrado."
            });
          } else {
            this.customerValidated = false;
            throw new Error("Hubo un error al intentar validar el cliente.");
          }
        }
      } catch (error) {
        console.log(`error expuesto manual: ${error}`);
        this.validatingCustomer = false;
      }
    },
    handleEmailChange() {
      this.customerValidated = false;
      this.customerValidationError = false;
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    //this.$refs.initial.$el.children[1].focus(); //focus 1st input on page load.
    document.getElementById("email").focus();
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
.ant-select-dropdown {
  width: auto;
}
.ant-select-dropdown-menu {
  max-height: auto;
}
</style>

<style>
.ant-input {
  height: inherit !important;
}
.ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 32px !important;
}
.ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 32px !important;
}
.ant-select-selection-selected-value {
  padding-right: 1px;
}
#custForm .ant-select-selection-selected-value {
  padding-right: 1px;
}
::placeholder {
  /* WebKit browsers */
  color: red;
  opacity: 1 !important;
}
.sinInteres {
  font-weight: bold;
  color: #169fc7;
}
</style>
